var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhilippines({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24_2619)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_2619",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_2619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2819 3H3V13.0033H37.2819V3Z",
    fill: "#303E99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2819 12.9967H3V22.9933H37.2819V12.9967Z",
    fill: "#BD1F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3V23L20.4088 12.9967L3 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35019 21.0716L4.58019 20.623L3.91731 21.2256L4.10479 20.3485L3.32809 19.9066L4.21862 19.8196L4.3994 18.9424L4.76097 19.7593L5.6515 19.6589L4.98193 20.2548L5.35019 21.0716Z",
    fill: "#F4D130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69368 11.1888L7.0442 10.0706L6.66924 10.0305L7.55977 11.2959L7.69368 11.1888ZM7.19151 11.6977L5.82559 10.6465L5.77872 10.0305L6.33446 10.0104L7.46603 11.3964L7.19151 11.6977ZM6.98394 11.9387L5.85907 11.3026L5.8122 10.9277L7.08437 11.8048L6.98394 11.9387Z",
    fill: "#F4D130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30734 10.9545L9.64882 9.70238L9.41447 9.40777L9.13995 10.9344L9.30734 10.9545ZM8.5909 10.9545L8.38333 9.24037L8.78507 8.77168L9.18682 9.15333L8.99264 10.9344L8.5909 10.9545ZM8.26951 10.9746L7.93472 9.72246L8.16907 9.42785L8.4436 10.9545L8.26951 10.9746Z",
    fill: "#F4D130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.613 11.9655L11.7513 11.3428L11.8048 10.9679L10.5126 11.8249L10.613 11.9655ZM10.1175 11.4433L11.2089 10.1041L11.8249 10.0706L11.8316 10.6264L10.4188 11.7245L10.1175 11.4433ZM9.88318 11.229L10.5461 10.1175L10.921 10.0773L10.0104 11.3361L9.88318 11.229Z",
    fill: "#F4D130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8139 13.5323L12.066 13.8738L12.3606 13.6394L10.834 13.3649L10.8139 13.5323ZM10.8206 12.8092L12.5347 12.6016L12.9967 13.0033L12.615 13.4051L10.834 13.2109L10.8206 12.8092ZM10.8005 12.4945L12.0526 12.1597L12.3472 12.394L10.8206 12.6686L10.8005 12.4945Z",
    fill: "#F4D130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86307 14.8045L10.5192 15.9227L10.8942 15.9628L9.99698 14.6974L9.86307 14.8045ZM10.3719 14.2889L11.7446 15.3334L11.7981 15.9494L11.2424 15.9695L10.1041 14.5902L10.3719 14.2889ZM10.5728 14.0479L11.7044 14.6773L11.7512 15.0522L10.4657 14.1818L10.5728 14.0479Z",
    fill: "#F4D130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2561 15.0388L7.92801 16.2909L8.16236 16.5855L8.43019 15.0589L8.2561 15.0388ZM8.97923 15.0388L9.20019 16.7529L8.79845 17.2216L8.39671 16.84L8.57749 15.0589L8.97923 15.0388ZM9.29393 15.0121L9.6421 16.2574L9.41445 16.5521L9.13323 15.0321L9.29393 15.0121Z",
    fill: "#F4D130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95714 14.0613L5.83226 14.704L5.78539 15.079L7.06427 14.2019L6.95714 14.0613ZM7.46601 14.5701L6.4014 15.9294L5.78539 15.9695L5.772 15.4138L7.1647 14.2956L7.46601 14.5701ZM7.70036 14.7777L7.05088 15.8959L6.68262 15.9428L7.57314 14.6706L7.70036 14.7777Z",
    fill: "#F4D130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7362 12.4811L5.48411 12.1463L5.1895 12.3807L6.71611 12.6485L6.7362 12.4811ZM6.7362 13.1975L5.0221 13.4185L4.55341 13.0167L4.93506 12.615L6.71611 12.7958L6.7362 13.1975ZM6.76298 13.5189L5.51758 13.8671L5.22297 13.6327L6.74289 13.3515L6.76298 13.5189Z",
    fill: "#F4D130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77839 10.8875C9.94344 10.8875 10.8875 11.8316 10.8875 12.9967C10.8875 14.1617 9.94344 15.1058 8.77839 15.1058C7.61334 15.1058 6.66925 14.1617 6.66925 12.9967C6.66925 11.8316 7.61334 10.8875 8.77839 10.8875Z",
    fill: "#F4D130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0365 13.7198L16.5655 12.9967L16.0365 12.2735L16.8802 12.5547L17.4091 11.8316L17.4024 12.7221L18.2528 12.9967L17.4024 13.2712L17.4091 14.1617L16.8869 13.4386L16.0365 13.7198Z",
    fill: "#F4D130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35019 4.7007L4.58019 5.15601L3.91731 4.5467L4.10479 5.42384L3.32809 5.86575L4.21862 5.95949L4.3994 6.83663L4.76097 6.01306L5.6515 6.11349L4.98193 5.51758L5.35019 4.7007Z",
    fill: "#F4D130"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24_2619",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_2619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_2619",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilippines);
export default __webpack_public_path__ + "static/media/Philippines.3b636514d2eeb27f9124a5885146566c.svg";
export { ForwardRef as ReactComponent };